function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import _get from 'lodash/get';
import _each from 'lodash/each';
import _isArray from 'lodash/isArray';
import { Auth } from 'aws-amplify';
import localStorage from 'store';
import { history } from 'js/store';
import { getCurrentLanguage } from 'js/helpers/localization';
import { IS_LOGGED_IN } from 'js/store/actions/auth';
import { AUTH_ROUTE_PATH } from 'js/constants/routes';

var getHttpEndpoint = function getHttpEndpoint(APP_ENV) {
  if (APP_ENV === 'production') {
    return process.env.COSMOS_DATA_API_URL;
  }

  if (APP_ENV === 'staging') {
    return process.env.COSMOS_DATA_API_URL;
  }

  return process.env.COSMOS_DATA_API_URL_DEV;
};

var API_BASE_URL = getHttpEndpoint(process.env.APP_ENV);
var API_ERROR_CODE_UNAUTHORIZED = 401;
var DOWNLOAD_LINK_URL = 'download_link';

function mapApiData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return data.data || data;
}

function constructApiDataUrl(url) {
  return "".concat(API_BASE_URL).concat(ensureBeginningSlash(url));
}

function constructApiDataUrlWithParamsStrings(url, paramsArray) {
  if (!_isArray(paramsArray)) return constructApiDataUrl(url);
  return constructApiDataUrl("".concat(url, "?").concat(paramsArray.join('&')));
}

export function constructApiDataUrlWithParamsObject(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var urlParamsArray = [];

  _each(params, function (value, key) {
    urlParamsArray.push("".concat(key, "=").concat(value));
  });

  return constructApiDataUrlWithParamsStrings(url, urlParamsArray);
}

function ensureBeginningSlash(url) {
  return url[0] === '/' ? url : "/".concat(url);
}

function callCosmosApi(unconstructedUrl) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new Promise(
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(resolve, reject) {
      var url, urlParamsArray, finalUrl;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = constructApiDataUrl(unconstructedUrl);
              urlParamsArray = [];

              _each(params.data, function (value, key) {
                urlParamsArray.push("".concat(key, "=").concat(value));
              });

              finalUrl = "".concat(url, "?").concat(urlParamsArray.join('&'));
              _context.t0 = fetch;
              _context.t1 = finalUrl;
              _context.next = 8;
              return getApiRequestHeaders();

            case 8:
              _context.t2 = _context.sent;
              _context.t3 = {
                method: 'GET',
                headers: _context.t2,
                mode: 'cors'
              };

              _context.t4 = function (response) {
                return response.json();
              };

              _context.t5 = function (apiData) {
                resolve(mapApiData(apiData));
              };

              _context.t6 = reject;
              (0, _context.t0)(_context.t1, _context.t3).then(_context.t4).then(_context.t5).catch(_context.t6);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
}

function addDefaultDataParameters() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.assign({
    language: getCurrentLanguage()
  }, data);
}

export function getCosmosApiData(url, data) {
  return callCosmosApi(url, {
    data: addDefaultDataParameters(data)
  });
}
export function postCosmosApiData(endpointUrl, getParams, body) {
  return callCosmosApiData(endpointUrl, 'POST', getParams, body);
}
export function putCosmosApiData(endpointUrl, getParams, body) {
  return callCosmosApiData(endpointUrl, 'PUT', getParams, body);
}

function callCosmosApiData(endpointUrl, method, getParams, body) {
  return new Promise(
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(resolve, reject) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = fetch;
              _context2.t1 = getParams ? constructApiDataUrlWithParamsObject(endpointUrl, getParams) : constructApiDataUrl(endpointUrl);
              _context2.next = 4;
              return getApiRequestHeaders();

            case 4:
              _context2.t2 = _context2.sent;
              _context2.t3 = JSON.stringify(body);
              _context2.t4 = {
                method: 'GET',
                mode: 'cors',
                headers: _context2.t2,
                body: _context2.t3
              };

              _context2.t5 = function (apiData) {
                resolve(mapApiData(apiData));
              };

              _context2.t6 = reject;
              (0, _context2.t0)(_context2.t1, _context2.t4).then(_context2.t5).catch(_context2.t6);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }());
} // Navigate to API data download URL code below


function rangeIsValid(range) {
  return _isArray(range) && range.length > 1;
}

function constructDateString(dateString) {
  var resultDate = new Date(dateString);
  var resultYear = resultDate.getUTCFullYear();
  var resultMonth = resultDate.getUTCMonth() + 1;

  if (resultMonth < 10) {
    resultMonth = "0".concat(resultMonth);
  }

  var resultDay = resultDate.getUTCDate();

  if (resultDay < 10) {
    resultDay = "0".concat(resultDay);
  }

  return "".concat(resultYear, "-").concat(resultMonth, "-").concat(resultDay);
}

export function constructCosmosApiDataDownloadUrl(dataUrl, range, sampleRate) {
  var params = {
    download: 1
  };

  if (rangeIsValid(range)) {
    params.startDate = constructDateString(range[0]);
    params.endDate = constructDateString(range[1]);
  }

  if (sampleRate) params.sampleRate = sampleRate;
  return constructApiDataUrlWithParamsObject("".concat(dataUrl, "/").concat(DOWNLOAD_LINK_URL), params);
}
export function setWindowLocationToUrl(url) {
  window.location = url;
}
export function apiErrorOccurred(errorXHRObject) {
  var errorStatusCode = String(_get(errorXHRObject, 'status', ''));
  if (errorStatusCode == API_ERROR_CODE_UNAUTHORIZED) clearAuthTokenAndRedirectToLogin(); // TODO: should this be more specific?

  return errorStatusCode[0] === '4';
}
export function clearAuthTokenAndRedirectToLogin() {
  localStorage.remove(IS_LOGGED_IN);
  history.push(AUTH_ROUTE_PATH);
}

function getApiRequestHeaders() {
  return _getApiRequestHeaders.apply(this, arguments);
}

function _getApiRequestHeaders() {
  _getApiRequestHeaders = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3() {
    var session;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return Auth.currentSession();

          case 2:
            session = _context3.sent;
            return _context3.abrupt("return", {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              cookies: session.accessToken.jwtToken
            });

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));
  return _getApiRequestHeaders.apply(this, arguments);
}